<template>
    <div>
        <div class="header">
            Elige un plan de regalo
        </div>
        <div class="head">
            <div class="block dedicate-phone">
                Has recibido esta clase como regalo de:
                <div>
                    <img src="../assets/images/CelebratKeter2.svg">
                </div>
                <div v-if="!donor.dedicationAnonymous">
                    {{donor.name}}
                </div>
                <div v-else>Anonymous</div>
                <div style="margin-top:50px;">
                    {{donor.dedicateLabel}}
                    {{donor.dedicationName}}
                </div>
            </div>
            <div class="dedicate-block">
                <h2>
                    Incluye tu nombre en la clase que estas regalando
                </h2>
                <div class="block">
                    <input type="text" v-model="donor.name" placeholder="Tu nombre aqui">
                    <label class="checkbox-container">
                        Permanecer Anónimo
                        <input v-model="donor.dedicationAnonymous" type="checkbox">
                        <span class="checkmark"></span>
                    </label>
                </div>
            </div>
            <div class="dedicate-man"></div>
        </div>


        <h2>
            Si lo deseas, también puedes dedicar la clase a una causa especial a elegir
        </h2>

        <div class="columns option-selection">
            <div class="column" v-for="type in types" @click="selectType(type)">
                <div class="block" :class="[donor.dedicationType == type.id? 'active' : '']">
                    <h3>
                        {{type.label}}
                    </h3>
                    <input v-if="donor.dedicationType == type.id" type="text" v-model="donor.dedicationName" placeholder="Nombre Apellido">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  components: {
  },
  props: {
      donor: {},
  },
  data: function() {
    return {
        types: [
            {label: "Para el éxito de", id: 1},
            {label: "En memoria de", id: 2},
            {label: "Para la pronta curación de", id: 3},
        ],
    };
  },
  computed: {
  },
  methods: {
    selectType(type) {
      this.donor.dedicationType = type.id;
      this.donor.dedicateLabel = type.label
    },
  }
};
</script>

<style scoped lang="scss">
.header {
  text-transform: uppercase;
  margin: 0 0 20px 0;
}
.head{
    background-image: url('../assets/images/DEDICATIONILLUSconfirmationBG.svg');
    height: 430px;
    background-repeat: no-repeat;
    background-size: contain;
    width: 890px;
    position: relative;
    margin: auto;
}
.dedicate-phone{
    position: absolute;
    left: 220px;
    top: 50px;
    height: 310px;
    width: 180px;
    padding: 20px;
    box-sizing: border-box;
    text-align: center;
}
.dedicate-block{
    width: 370px;
    height: 220px;
    position: absolute;
    right: -10px;
    top: 60px;
}
.dedicate-man{
    background-image: url('../assets/images/DedicationMan.svg');
    height: 100%;
    background-repeat: no-repeat;
    z-index: 99999;
    left: 40px;
    position: absolute;
    width: 300px;
    bottom: 9px;
}
</style>
<style scoped lang="scss">
.option-selection{
    .block{
        cursor: pointer;
    }
}
.columns .column{
    width: 32%;
}
.block{
    padding: 30px;
}
.block input[type="text"]{
    line-height: 2em;
    width: 100%;
    padding: 5px 10px;
    border: 0.868376px solid rgba(44, 43, 86, 0.15);
    box-sizing: border-box;
    box-shadow: inset 0px 4px 4px rgba(45, 43, 169, 0.1);
    border-radius: 30px;
    margin-bottom: 20px;
}
h1, h2, h3, h4, .header{
    color: rgba(73, 73, 73, 0.77);
    font-weight: normal;
    text-align: center;
    text-transform: uppercase;
}
@media only screen and (max-width: 600px) {
    .head{
        background-image: url('../assets/images/DedicationIllusMobileBg.svg');
        width: 100%;
        margin-left: -10px;
    }
    .head .dedicate-block{
        width: 100%;
        box-sizing: border-box;
    }
    .block.dedicate-phone, .dedicate-man{
        display: none;
    }
    .head .dedicate-block{
        height: auto;
    }
    .columns {
        display: block;
    }
    .columns .column{
        width: 100%;
        .block{
            padding: 10px;
            margin-bottom: 20px;
        }
    }
}
</style>